import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M21 18l-3-3v2H5v2h13v2l3-3zM9.5 11.8h5l.9 2.2h2.1L12.75 3h-1.5L6.5 14h2.1l.9-2.2zM12 4.98L13.87 10h-3.74L12 4.98z"
}), 'TextRotationNoneSharp');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/TextRotationNoneSharp.js
// module id = 6747
// module chunks = 2